export * from './delete-bericht.command.module';
export * from './component';
export * from './service';